import { clientEnv } from "src/config/clientEnv";

const stripDots = (value: string) => value.replace(/^\.+|\.+$/g, "");

function getConfiguredDevBaseDomain(): string | null {
  const value = clientEnv.devBaseDomain;
  return value ? stripDots(value) : null;
}

function deriveBaseDomain(hostname: string): string {
  if (hostname === "localhost" || hostname.endsWith(".localhost")) {
    return "localhost";
  }
  if (hostname.endsWith(".ngrok.io") || hostname.endsWith(".ngrok.dev")) {
    return hostname;
  }
  const labels = hostname.split(".");
  return labels.length > 2 ? labels.slice(1).join(".") : hostname;
}

function isNgrokHost(hostname: string): boolean {
  return hostname.endsWith(".ngrok.io") || hostname.endsWith(".ngrok.dev");
}

function getPortForTarget(domain: string): string {
  if (domain.includes(":")) return "";
  if (getConfiguredDevBaseDomain() && clientEnv.devHttpsPort) {
    return `:${clientEnv.devHttpsPort}`;
  }
  return window.location.port ? `:${window.location.port}` : "";
}

export function buildUrlForDomain(domain: string): string {
  const protocol = window.location.protocol;
  const path = window.location.pathname + window.location.search;
  return `${protocol}//${domain}${getPortForTarget(domain)}${path}`;
}

export function buildTenantSubdomainUrl(subdomain: string): string {
  const configuredDevBaseDomain = getConfiguredDevBaseDomain();
  if (!configuredDevBaseDomain && isNgrokHost(window.location.hostname)) {
    return buildUrlForDomain(window.location.host);
  }

  const baseDomain =
    configuredDevBaseDomain ?? deriveBaseDomain(window.location.hostname);
  const domain =
    baseDomain === "localhost"
      ? `${subdomain}.localhost`
      : `${subdomain}.${baseDomain}`;
  return buildUrlForDomain(domain);
}
